import chroma from 'chroma-js';
import _range from 'lodash/range';

export const COLOR_RANGE_STEPS_MIN = 3;
export const COLOR_RANGE_STEPS_MAX = 5;
export const COLOR_RANGE_STEPS_DEFAULT = 5;
export const RENDERER_COLOR_RANGES = [
  ['#f5f502', '#f50100'],
  ['#fef0d9', '#b30000'],
  ['#edf8fb', '#006d2c'],
  ['#edf8fb', '#810f7c'],
  ['#f0f9e8', '#0868ac'],
  ['#f1eef6', '#980043'],
];
export const COLOR_RANGE_STEPS_DROPDOWN = _range(COLOR_RANGE_STEPS_MIN, COLOR_RANGE_STEPS_MAX + 1);
export const COLOR_RANGE_1 = chroma.scale(RENDERER_COLOR_RANGES[0]).mode('lch').colors(COLOR_RANGE_STEPS_MAX);
export const COLOR_RANGE_2 = chroma.scale(RENDERER_COLOR_RANGES[1]).mode('lch').colors(COLOR_RANGE_STEPS_MAX);
export const COLOR_RANGE_3 = chroma.scale(RENDERER_COLOR_RANGES[2]).mode('lch').colors(COLOR_RANGE_STEPS_MAX);
export const COLOR_RANGE_4 = chroma.scale(RENDERER_COLOR_RANGES[3]).mode('lch').colors(COLOR_RANGE_STEPS_MAX);
export const COLOR_RANGE_5 = chroma.scale(RENDERER_COLOR_RANGES[4]).mode('lch').colors(COLOR_RANGE_STEPS_MAX);
export const COLOR_RANGE_6 = chroma.scale(RENDERER_COLOR_RANGES[5]).mode('lch').colors(COLOR_RANGE_STEPS_MAX);
export const COLOR_RANGES = [COLOR_RANGE_1, COLOR_RANGE_2, COLOR_RANGE_3, COLOR_RANGE_4, COLOR_RANGE_5, COLOR_RANGE_6];

export const ADDITIONAL_EXTERNAL_FIELDS = [
  { name: 'Value', alias: 'Value', type: 'double' },
  { name: 'Population_at_risk', alias: 'Population_at_risk', type: 'double' },
  { name: 'Uncertainty_Interval', alias: 'Uncertainty_Interval', type: 'double' },
  { name: 'region_id', alias: 'region_id', type: 'string' },
];
